import React, {Component} from 'react'
import propTypes from 'prop-types'
import PartCategoryTreeSelectFieldContainer from 'components/partCategoryTreeSelectField'

class PartCategorySelectField extends Component {
  constructor(props) {
    super(props)
    this.partCategoryRef = React.createRef()
  }

  focus = () => {
    this.partCategoryRef.current.focus()
  }

  onSave = () => {

  }

  onClear = () => {

  }

  render() {
    const {value} = this.props
    return (
        <PartCategoryTreeSelectFieldContainer
            partCategoryRef={this.partCategoryRef}
            {...this.props}
            partCategory={value}
            isInEditableFieldList={true}
            isNodeSelectable={true}
            onSave={this.onSave}
            onClear={this.onClear}
        />
    )
  }
}

PartCategorySelectField.propTypes = {
  value: propTypes.object,
}

export default PartCategorySelectField
